"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var ENUM$ACTIONS = {
  aaa: 'action:aaa',
  bbb: 'action:bbb',
  ccc: 'action:ccc',
  changePeople: 'action:changePeople',
  setGuide: 'action:setGuide',
  changeAddress: 'action:changeAddress',
  changeStore: 'action:changeStore'
};

var _getMessageInfo = function _getMessageInfo(key) {
  return localStorage.getItem(key);
};

var onMessageListen = function onMessageListen() {
  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return null;
  };
  window.addEventListener('storage', function (e) {
    var key = e.key;

    if (keys.includes(key)) {
      var res = _getMessageInfo(e.key);

      if (!(res === null)) {
        console.log("%cstorageMessage:".concat(e.key), 'color:green;');
        console.log(e);
        console.log(res);
        setTimeout(function () {
          localStorage.removeItem(e.key);
        }, 1000);
        callback(key, res);
      }
    }
  });
};

var postMessage = function postMessage(key, val) {
  localStorage.setItem(key, val);
};

var _default = {
  ENUM$ACTIONS: ENUM$ACTIONS,
  postMessage: postMessage,
  onMessageListen: onMessageListen
};
exports["default"] = _default;